

import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import { SalesOrderService } from "../../../services/salesOrder.service";
import {
  Combo2Service,
  ExcelService,
  PurchaseReportService,
} from "../../../services/index";
declare var google;

@Component({
  selector: "textile-stock-report",
  templateUrl: "./textileStockReport.html",
})
export class textileStockReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  gridOptions: any;
  dataList = [];
  qualityList: any;
  typeList: any;
  backbutExists: boolean = false;
  columnList = [];
  codeList: any;
  widthList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  finyearList = [];
  // groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  filter = {
    groupby: "total_stock",
    style: "",
    stock_type: "total_stock",
    variety: "",
    design: "",
    design_color: "",
    width: "",
    type: "",
    to_make: "",
    size: "",
    fab_style: "",
    agent_id: '',
    party_id: '',
    invoice_id: '',
    outward_type: '',
    color: '',
    aoid: '',
    menu_param: ''
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "po_no",
    orderDir: "asc",
  };
  printConfig: any = {
    title: "Open Order Report",
    columns: [],
    rows: [],
  };

  colorList = ["lightcyan", "bisque", "lightblue", "lightgoldenrodyellow", "thistle", "floralwhite", "#cc97ca", "#f2cd75", "lightgrey", "#ccebcc"];

  partyList = [];
  exceldata: any;

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  columns = [];
  partycodeList = [];
  toggleCol = [];
  menu: any;
  reportTypeList = ["DESIGN NO", "PARTY", "PURCHASE"];
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  swatchList = ["YES", "NO"];
  sampList = ["YES", "NO"];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  group1 = {
    tot_mtrs: 0,
    value: 0,
    approx_shirts: 0
  }
  group2 = {
    tot_mtrs: 0,
    value: 0,
    approx_shirts: 0
  }
  group3 = {
    tot_mtrs: 0,
    value: 0,
    approx_shirts: 0
  }
  group4 = {
    tot_mtrs: 0,
    value: 0,
    approx_shirts: 0
  }
  constructor(
    public store: Store<fromRootStore.State>,
    private excelService: ExcelService,
    private purReport: PurchaseReportService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    private salesOrderServ: SalesOrderService,
    public toasterService: ToasterService
  ) { }

  ngOnInit(): void {
    this.getColumns();
    this.finyearCombo();
    this.toggleCol = Object.assign({}, this.columns);

    this.filter.menu_param = this.menu.param;
  }

  hotkeys(event) {
    if (this.active) {
    }
  }
  backbutton() {
    if ($(".data-history-btn").length) {
      this.backbutExists = false;
    } else {
      this.backbutExists = true;
    }
  }
  getColumns() {
    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  onCellClick(event) {
    this.backbutExists = true;

    let row = event.row;
    if (this.filter.groupby == "total_stock") {
      row = event;
    }

    if (this.filter.groupby == "total_stock") {
      // setTimeout(() => {
      this.filter.stock_type = row.categery;
      // ;},0)
    }
    if (this.filter.stock_type == "SAMPLE") {
      if (this.filter.groupby == "total_stock") {
        // this.filter.style = row.TYPE;
        this.filter.groupby = "style";

      }
      else if (this.filter.groupby == "style") {

        this.filter.style = row.style;
        this.filter.groupby = "variety";
      }
      else if (this.filter.groupby == "variety") {

        this.filter.style = row.style;
        this.filter.type = row.type;
        this.filter.groupby = "width";
      }
      else if (this.filter.groupby == "width") {

        this.filter.style = row.style;
        this.filter.type = row.type;
        this.filter.width = row.recvd_width;
        this.filter.groupby = "design_no";
      }
      else if (this.filter.groupby == "design_no") {
        this.filter.style = row.style;
        this.filter.type = row.type;
        this.filter.width = row.recvd_width;
        this.filter.design = row.design_no;

        this.filter.groupby = "barcode";
      }

    }
    if (this.filter.stock_type == "BULK") {
      if (this.filter.groupby == "total_stock") {
        // this.filter.style = row.TYPE;
        this.filter.groupby = "style";

      }
      else if (this.filter.groupby == "style") {

        this.filter.style = row.style;
        this.filter.groupby = "variety";
      }
      else if (this.filter.groupby == "variety") {

        this.filter.style = row.style;
        this.filter.type = row.type;
        this.filter.groupby = "width";
      }
      else if (this.filter.groupby == "width") {

        this.filter.style = row.style;
        this.filter.type = row.type;
        this.filter.width = row.width;
        this.filter.groupby = "design_no";
      }
      else if (this.filter.groupby == "design_no") {
        this.filter.style = row.style;
        this.filter.type = row.type;
        this.filter.width = row.width;
        this.filter.design = row.design_no;

        this.filter.groupby = "barcode";
      }

    }
    if (this.filter.stock_type == "MATCHING") {
      if (this.filter.groupby == "total_stock") {
        // this.filter.style = row.TYPE;
        this.filter.groupby = "design_no";

      }
      else if (this.filter.groupby == "design_no") {

        this.filter.design = row.design_no;
        this.filter.groupby = "color";
      }
      else if (this.filter.groupby == "color") {

        this.filter.color = row.color;
        this.filter.groupby = "barcode";
      }
    }
    if (this.filter.stock_type == "FANCY") {
      if (this.filter.groupby == "total_stock") {
        // this.filter.style = row.TYPE;
        this.filter.groupby = "design_no";

      }
      else if (this.filter.groupby == "design_no") {

        this.filter.design = row.design_no;
        this.filter.groupby = "color";
      }
      else if (this.filter.groupby == "color") {

        this.filter.color = row.color;
        this.filter.groupby = "barcode";
      }

    }
    if (this.filter.stock_type == "SUITING") {
      if (this.filter.groupby == "total_stock") {
        // this.filter.style = row.TYPE;
        this.filter.groupby = "design_no";

      }
      else if (this.filter.groupby == "design_no") {

        this.filter.design = row.design_no;
        this.filter.groupby = "color";
      }
      else if (this.filter.groupby == "color") {

        this.filter.color = row.color;
        this.filter.groupby = "barcode";
      }
    }
    if (this.filter.stock_type == "BITZ") {
      if (this.filter.groupby == "total_stock") {
        this.filter.groupby = "to_make";
      }
      else if (this.filter.groupby == "to_make") {

        this.filter.to_make = row.type;
        this.filter.groupby = "width";
      }
      else if (this.filter.groupby == "width") {

        this.filter.width = row.width;
        this.filter.to_make = row.type;
        this.filter.size = row.size;
        this.filter.groupby = "style";
      }
      else if (this.filter.groupby == "style") {

        this.filter.width = row.width;
        this.filter.to_make = row.type;
        this.filter.fab_style = row.fab_style;
        this.filter.size = row.size;
        this.filter.groupby = "BIT";
      }
    }
    if (this.filter.stock_type == "JGRN") {
      if (this.filter.groupby == "total_stock") {
        // this.filter.style = row.TYPE;
        this.filter.groupby = "design_no";

      }
      else if (this.filter.groupby == "design_no") {

        this.filter.design = row.design_no;
        this.filter.groupby = "color";
      }
      else if (this.filter.groupby == "color") {

        this.filter.color = row.color;
        this.filter.groupby = "barcode";
      }
    }
    if (this.filter.stock_type == "JOBWORK DC") {
      if (this.filter.groupby == "total_stock") {
        // this.filter.style = row.TYPE;
        this.filter.groupby = "date_wise";

      }
      else if (this.filter.groupby == "date_wise") {

        this.filter.design = row.dc_id;
        this.filter.groupby = "entry_wise";
      }

    }
    if (this.filter.stock_type == "DAMAGE STOCK") {
      if (this.filter.groupby == "total_stock") {
        // this.filter.style = row.TYPE;
        this.filter.groupby = "damdate_wise";

      }
      else if (this.filter.groupby == "damdate_wise") {

        this.filter.design = row.wo_in_id;
        this.filter.groupby = "damentry_wise";
      }

    }
    this.gettextileStockReport();
  }

  onbackbutton() {
    if (this.filter.stock_type == "SAMPLE") {
      if (this.filter.groupby == "barcode") {
        this.filter.design = "";
        this.filter.groupby = "design_no";
      } else if (this.filter.groupby == "design_no") {
        this.filter.width = "";
        this.filter.groupby = "width";
      } else if (this.filter.groupby == "width") {
        this.filter.type = "";
        this.filter.groupby = "variety";
      } else if (this.filter.groupby == "variety") {

        this.filter.type = "";
        this.filter.groupby = "style";
      }
      else if (this.filter.groupby == "style") {

        this.filter.style = "";
        this.filter.groupby = "total_stock";
        this.filter.stock_type = "total_stock";

      }
    }
    else if (this.filter.stock_type == "BULK") {
      if (this.filter.groupby == "barcode") {
        this.filter.design = "";
        this.filter.groupby = "design_no";
      } else if (this.filter.groupby == "design_no") {
        this.filter.width = "";
        this.filter.groupby = "width";
      } else if (this.filter.groupby == "width") {
        this.filter.type = "";
        this.filter.groupby = "variety";
      } else if (this.filter.groupby == "variety") {

        this.filter.type = "";
        this.filter.groupby = "style";
      }
      else if (this.filter.groupby == "style") {

        this.filter.style = "";
        this.filter.groupby = "total_stock";
        this.filter.stock_type = "total_stock";

      }
    }
    else if (this.filter.stock_type == "MATCHING") {
      if (this.filter.groupby == "barcode") {
        this.filter.color = "";
        this.filter.groupby = "color";

      }
      else if (this.filter.groupby == "color") {

        this.filter.design = "";
        this.filter.groupby = "design_no";

      }
      else if (this.filter.groupby == "design_no") {

        this.filter.groupby = "total_stock";
        this.filter.stock_type = "total_stock";

      }
    }
    else if (this.filter.stock_type == "FANCY") {
      if (this.filter.groupby == "barcode") {
        this.filter.color = "";
        this.filter.groupby = "color";

      }
      else if (this.filter.groupby == "color") {

        this.filter.design = "";
        this.filter.groupby = "design_no";

      }
      else if (this.filter.groupby == "design_no") {

        this.filter.groupby = "total_stock";
        this.filter.stock_type = "total_stock";

      }

    }
    else if (this.filter.stock_type == "SUITING") {
      if (this.filter.groupby == "barcode") {
        this.filter.color = "";
        this.filter.groupby = "color";

      }
      else if (this.filter.groupby == "color") {

        this.filter.design = "";
        this.filter.groupby = "design_no";

      }
      else if (this.filter.groupby == "design_no") {

        this.filter.groupby = "total_stock";
        this.filter.stock_type = "total_stock";

      }

    }
    else if (this.filter.stock_type == "BITZ") {
      if (this.filter.groupby == "BIT") {
        this.filter.fab_style = "";
        this.filter.groupby = "style";

      }
      else if (this.filter.groupby == "style") {

        this.filter.groupby = "width";
        this.filter.width = "";
        this.filter.size = "";
      }
      else if (this.filter.groupby == "width") {

        this.filter.groupby = "to_make";
        this.filter.to_make = "";
      }
      else if (this.filter.groupby == "to_make") {

        this.filter.groupby = "total_stock";
        this.filter.stock_type = "total_stock";
      }
    }
    else if (this.filter.stock_type == "JGRN") {
      if (this.filter.groupby == "barcode") {
        this.filter.color = "";
        this.filter.groupby = "color";

      }
      else if (this.filter.groupby == "color") {

        this.filter.design = "";
        this.filter.groupby = "design_no";

      }
      else if (this.filter.groupby == "design_no") {

        this.filter.groupby = "total_stock";
        this.filter.stock_type = "total_stock";

      }

    }
    else if (this.filter.stock_type == "JOBWORK DC") {
      if (this.filter.groupby == "entry_wise") {
        this.filter.design = "";
        this.filter.groupby = "date_wise";

      }

      else if (this.filter.groupby == "date_wise") {

        this.filter.groupby = "total_stock";
        this.filter.stock_type = "total_stock";

      }

    }
    if (this.filter.stock_type == "DAMAGE STOCK") {
      if (this.filter.groupby == "damentry_wise") {
        this.filter.design = "";
        this.filter.groupby = "damdate_wise";

      }

      else if (this.filter.groupby == "damdate_wise") {

        this.filter.groupby = "total_stock";
        this.filter.stock_type = "total_stock";

      }

    }
    this.gettextileStockReport();
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.gettextileStockReport();
  }

  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.finyearCtrl.setValue(res.data[0].fin_id);
      this.gettextileStockReport();
    });
  }

  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  gettextileStockReport(): void {
    let params = {
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };
    //this.store.dispatch(new commonActions.LoadAllParty(params));
     let tot_shirts = 0;
    that.isLoadMask = that.salesOrderServ
      .gettextileStockReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
         let temp = 0;
        res.data.forEach((el, ind) => {
          if(ind >= 10){
           temp = temp + 1;
           if(temp == 10){
              temp = 0;
           }
           el['background'] = that.colorList[temp];
          }
          else{
          el['background'] = that.colorList[ind];
          }
           tot_shirts += Math.round(el.approx_shirts);
        });
        res.data.forEach(e => {
          e.stock_per = ((e.approx_shirts / Number(tot_shirts)) * 100).toFixed(2);
          
        });
        if (that.filter.stock_type == 'total_stock') {
     
       

          let groupStockList = res.data.reduce((res, cur) => {
            (res[cur['groupes']] = res[cur['groupes']] || []).push(cur);
            return res;
          }, {});

          that.group1 = {
            tot_mtrs: 0,
            value: 0,
            approx_shirts: 0
          }
          that.group2 = {
            tot_mtrs: 0,
            value: 0,
            approx_shirts: 0
          }
          that.group3 = {
            tot_mtrs: 0,
            value: 0,
            approx_shirts: 0
          }
          that.group3 = {
            tot_mtrs: 0,
            value: 0,
            approx_shirts: 0
          }
          that.group4 = {
            tot_mtrs: 0,
            value: 0,
            approx_shirts: 0
          }
          groupStockList['group1'].forEach((el) => {
            el.tot_mtrs = Math.round(el.tot_mtrs);
            that.group1.tot_mtrs += el.tot_mtrs;
            el.value = Math.round(el.value);
            that.group1.value += el.value;
            that.group1.approx_shirts += Math.round(el.approx_shirts);

          });

          groupStockList['group2'].forEach((el) => {
            el.tot_mtrs = Math.round(el.tot_mtrs);
            that.group2.tot_mtrs += el.tot_mtrs;
            el.value = Math.round(el.value);
            that.group2.value += el.value;
            that.group2.approx_shirts += Math.round(el.approx_shirts);
          });

          groupStockList['group3'].forEach((el) => {
            el.tot_mtrs = Math.round(el.tot_mtrs);
            that.group3.tot_mtrs += el.tot_mtrs;
            el.value = Math.round(el.value);
            that.group3.value += el.value;
            that.group3.approx_shirts += Math.round(el.approx_shirts);
          });
          groupStockList['group4'].forEach((el) => {
            el.tot_mtrs = Math.round(el.tot_mtrs);
            that.group4.tot_mtrs += el.tot_mtrs;
            el.value = Math.round(el.value);
            that.group4.value += el.value;
            that.group4.approx_shirts += Math.round(el.approx_shirts);
          });
          // for(ar in arr){
          //   arr[ar].reduce((res, cur) => {
          //     return {pcs : cur.tot_mtrs + res.pcs}
          //   }, {});
          // }


        }

        that.page.count = res.totCnt;
        that.orderList = res.data;
        that.columnList = res.columns;



        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };

         if(that.filter.stock_type !=='total_stock'){
            let menuObj3 = {
              cellClass: "txtCenter",
              name: "%",
              prop: "stock_per",
              summary: "sum",
              width: "120",
            };
            that.gridOptions.columns.push(menuObj3);
          }
        that.printConfig = {
          title: "Cutting Report",
          columns: res.columns,
          rows: that.orderList,
        };
        that.exceldata = that.getData(res.columns, res.data);
        that.backbutton();
      });
  }

  getData(columns, data) {
    console.log(data)
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}




// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/textileStockReport/textileStockReport.ts